import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { ErrorDialog } from '../models/error-dialog.model';

@Injectable({
    providedIn: 'root'
})
export class ErrorDialogService {
    private readonly _error: BehaviorSubject<ErrorDialog>;

    constructor() {
        this._error = new BehaviorSubject<ErrorDialog>(null);
    }

    public showErrorDialog(errorDialog: ErrorDialog) {
        this._error.next(errorDialog);
    }

    public get error(): Observable<ErrorDialog> {
        return this._error.asObservable();
    }
}
